@if (show()) {
  <div class="text-end">
    @if (!charsLeftThreshold() || charsLeft() < charsLeftThreshold()) {
      <span [class.text-danger]="isFull()">{{ charsLeft() }}</span>
      <span class="text-muted">/ {{ maxLength() }}</span>
    }
  </div>
}
